import type { LayerLibraryRow } from './types';

/** Text fields searched by the Layer Library global search. */
const SEARCHABLE_FIELDS: Array<keyof LayerLibraryRow> = ['name', 'category', 'source', 'description'];

/**
 * Client-side global search over a layer catalog. Case-insensitive substring match
 * across the searchable text fields. An empty/whitespace query returns all rows.
 *
 * Pure helper so the table wrapper can both filter rows and derive an accurate
 * pagination total without double-filtering.
 */
export function searchLayers<T extends LayerLibraryRow>(rows: T[], query: string): T[] {
  const q = query.trim().toLowerCase();
  if (!q) return rows;
  // Optional chaining: absent optional fields (source/description) must not match —
  // String(undefined) would be the literal "undefined" and match queries like "und".
  // Sub-layers matched separately: they're {name,type} objects, not primitive text fields.
  return rows.filter(
    (row) =>
      SEARCHABLE_FIELDS.some((field) => row[field]?.toString().toLowerCase().includes(q)) ||
      row.subLayers?.some((sub) => sub.name.toLowerCase().includes(q)),
  );
}
